import { render, staticRenderFns } from "./formAnswerRank.vue?vue&type=template&id=47d27ab6&scoped=true&"
import script from "./formAnswerRank.vue?vue&type=script&lang=js&"
export * from "./formAnswerRank.vue?vue&type=script&lang=js&"
import style0 from "./formAnswerRank.vue?vue&type=style&index=0&id=47d27ab6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47d27ab6",
  null
  
)

export default component.exports